
  Vue.component('lr-menu-item', {
    props: {
      id: Number,
      label: String,
      iconClass: {
        default: 'fa-circle',
        type: String
      },
      isActive: Boolean,
      url: {
        default: '#',
        type: String
      },
      menuKeys: {
        type: Array
      }
    },
    data() {
      return {}
    },
    template: '#lr-menu-item',
    computed: {},
    watch: {},
    methods: {},
    mounted() {}
  })
